export const getFileSize = (size) => {
  if (size > 1024 * 1024) {
    return `${Math.round(size / (1024 * 1024))} MB`;
  } else if (size > 1024) {
    return `${Math.round(size / 1024)} KB`;
  } else {
    return `${size} B`;
  }
};
